import RecordingTable from "./recording-table";

export default RecordingTable